export default "__VITE_ASSET__CkzULMYj__"